module.exports = __webpack_public_path__ + "img/xxjs.b0148133.png";